import * as API from "./httpService"
import * as CommonFunction from "../common/function"
import { updateUiData, updateDropdown, updateFromGetData } from "../redux/actions"
import {
  policyValidationAlert,
  backendDownNotice,
} from "../services/sweetalertService"
import { element } from "prop-types"

export function GetPolicyInfo(getPolicyInfoRequestModel) {
  return dispatch => {
    API.apiPostRequest("/Claim/PetPolicyInfo", getPolicyInfoRequestModel, null)
      .then(response => {
        const { UpStatus, IsValidPolicy, StartDate, PetDOB, PetMicrochipNo  } = response.data

        //Backend Up + Policy valid
        if (UpStatus.toLowerCase() === "true" && IsValidPolicy === "Y") {
          dispatch(updateUiData("showLoading", false))
          dispatch(updateUiData("maxPageNumber", 2))
          dispatch(updateUiData("policyStartDate", StartDate))
          dispatch(updateUiData("petDOB", PetDOB))
          if (PetDOB) {
            const [year, month, day] = PetDOB.split("-")
            dispatch(updateFromGetData("petDateofBirth", `${day}/${month}/${year}`))
            dispatch(updateUiData("disablePetDOBField", true))
          } else {
            dispatch(updateUiData("disablePetDOBField", false))
          }

          if (PetMicrochipNo) {
            dispatch(updateFromGetData("petMicrochipNumber", PetMicrochipNo))
            dispatch(updateUiData("disablePetMicroField", true))
          } else {
            dispatch(updateUiData("disablePetMicroField", false))
          }
          CommonFunction.navigateToPetDetail()
          //CommonFunction.navigateToSupportingDocument()

          //Backend Up + Policy invalid
        } else if (UpStatus.toLowerCase() === "true" && IsValidPolicy === "N") {
          dispatch(updateUiData("showLoading", false))
          //dispatch(updateUiData("maxPageNumber", 2))
          console.log("In")
          policyValidationAlert()

          //Backend Down
        } else if (UpStatus.toLowerCase() === "false") {
          dispatch(updateUiData("showLoading", false))
          backendDownNotice()
        }
      })
      .catch(error => {
        dispatch(updateUiData("showLoading", false))
        console.log("Out")
        policyValidationAlert()
      })
  }
}

export function CalculateCoinsuranceRate(petDateofBirth,policyStartDate) {
  return dispatch => {
    const formatPolicyStartDate = dateValue => {
      if (!dateValue) return null

      if (dateValue.includes("/")) {
        const [day, month, year] = dateValue.split("/")
        if (day && month && year) {
          const parsedDate = new Date(
            Date.UTC(Number(year), Number(month) - 1, Number(day), 0, 0, 0)
          )

          if (!Number.isNaN(parsedDate.getTime())) {
            return parsedDate.toISOString()
          }
        }
      }

      const parsedDate = new Date(dateValue)
      if (!Number.isNaN(parsedDate.getTime())) {
        return parsedDate.toISOString()
      }

      return dateValue
    }

    const formattedPolicyStartDate = formatPolicyStartDate(policyStartDate)

    API.apiPostRequest(
      "/Claim/CalculateCoinsuranceRate",
      {
        petDOB: petDateofBirth,
        policyStartDate: formattedPolicyStartDate,
      },
      null
    )
      .then(response => {
        dispatch(updateUiData("coinsuranceRate", response.data.CoinsuranceRate))
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
  }
}

export function GetRequiredDocuments(coverageDetailId) {
  return dispatch =>
    API.apiPostRequest(
      "/Claim/GetRequiredDocumentList",
      {
        coverageId: coverageDetailId,
      },
      null
    )
      .then(response => {
        let listOfRequiredDocuments = response.data
        listOfRequiredDocuments.forEach(requiredDocument => {
          requiredDocument.visible = true
        })

        dispatch(updateUiData("proofDocuments", listOfRequiredDocuments))
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function GetDropdownData(tableName) {
  return dispatch =>
    API.apiPostRequest("/Claim/CommonDropDownList", null, {
      params: {
        name: tableName,
      },
    })
      .then(response =>
        dispatch(
          updateDropdown(response.data.TableName, response.data.CodeTables)
        )
      )
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function GetNationalityData() {
  return dispatch =>
    API.apiPostRequest("/Claim/NationalityDropDownList", null, null)
      .then(response => dispatch(updateDropdown("Nationality", response.data)))
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function SubmitClaim(claimData, uiData) {
  //Common start
  var submitData = claimData

  if (!submitData.petClaimHeaderModel.sourceSystem) {
    submitData.petClaimHeaderModel.sourceSystem = "Web"
  }
  submitData.petClaimDetailsModel.declaration = uiData.checkBoxStatus.isAgree
  //Common end

  if (submitData.petClaimDetailsModel.petDateofBirth) {
    submitData.petClaimDetailsModel.petDateofBirth = CommonFunction.combineDateAndTime(
      CommonFunction.convertTextDateToDateTime(
        submitData.petClaimDetailsModel.petDateofBirth
      ),
      "00:00"
    )
  }
  //check & convert datetime field
  if (submitData.selectedBenefitsDetail != undefined) {
    submitData.selectedBenefitsDetail.forEach((element, index) => {
      //use after deductible instead if having value (this for accident and illness type)
      if (element.claimAmountAfterDeductible > 0) {
        submitData.selectedBenefitsDetail[index].claimAmount = parseFloat(
          element.claimAmountAfterDeductible.toFixed(2)
        )
      }

      if (element.symptomsStartDate != "") {
        submitData.selectedBenefitsDetail[
          index
        ].symptomsStartDate = CommonFunction.combineDateAndTime(
          CommonFunction.convertTextDateToDateTime(element.symptomsStartDate),
          "00:00"
        )
      }

      if (element.firstTreatedDate != "") {
        submitData.selectedBenefitsDetail[
          index
        ].firstTreatedDate = CommonFunction.combineDateAndTime(
          CommonFunction.convertTextDateToDateTime(element.firstTreatedDate),
          "00:00"
        )
      }

      if (element.lastFirstTreatedDate != "") {
        submitData.selectedBenefitsDetail[
          index
        ].lastFirstTreatedDate = CommonFunction.combineDateAndTime(
          CommonFunction.convertTextDateToDateTime(
            element.lastFirstTreatedDate
          ),
          "00:00"
        )
      }

      if (element.acciedentDate != "") {
        submitData.selectedBenefitsDetail[
          index
        ].acciedentDate = CommonFunction.combineDateAndTime(
          CommonFunction.convertTextDateToDateTime(element.acciedentDate),
          "00:00"
        )
      }

      if (element.dateOfDeath != "") {
        submitData.selectedBenefitsDetail[
          index
        ].dateOfDeath = CommonFunction.combineDateAndTime(
          CommonFunction.convertTextDateToDateTime(element.dateOfDeath),
          "00:00"
        )
      }

      if (element.incidentNotifiedDate != "") {
        submitData.selectedBenefitsDetail[
          index
        ].incidentNotifiedDate = CommonFunction.combineDateAndTime(
          CommonFunction.convertTextDateToDateTime(
            element.incidentNotifiedDate
          ),
          "00:00"
        )
      }
    })
  }

  return dispatch =>
    API.apiPostRequest(
      "/Claim/PetSubmitClaim",
      {
        // Policy Information
        claimHeaderModel: submitData.petClaimHeaderModel,
        // Details
        claimPetDetailModel: submitData.petClaimDetailsModel,
        // Benefits Details
        claimPetLossDetailModel: submitData.selectedBenefitsDetail,
        //Common data
        claimUploadListModel: uiData.claimUploadListModel,
        folderName: uiData.folderName,
        sessionId: uiData.folderName,
      },
      null
    )
      .then(submitClaimResponse => {
        dispatch(
          updateUiData(
            "submittedClaimID",
            submitClaimResponse.data.ClaimRequestNumber
          )
        )
        CommonFunction.navigateToSubmittedClaim()
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
}

export function GetBankListData() {
  return dispatch =>
    API.apiPostRequest("/Claim/BankList", null, null)
      .then(response => {
        // Add an empty slection in banklist
        // const emptyBank = {
        //   Bank_Id: 0,
        //   Bank_Name: "",
        //   BIC: "",
        //   IsValid: true,
        //   RegexValidation: "",
        //   RegexValidationJs: "",
        //   ErrorMessage: "",
        // }
        let banklistResult = null
        // if (response.data) {
        //   banklistResult = [emptyBank].concat(response.data)
        // } else {
        //   banklistResult = emptyBank
        // }

        banklistResult = response.data

        dispatch(updateUiData("bankList", banklistResult))

        // CommonFunction.navigateToPaymentDetail()
      })
      .catch(error => {
        CommonFunction.navigateToError()
      })
}
